import { api } from '../config'

export const EVENTSBOARD_URL = {
  getEvents: (eventName: string) =>
    `${api.withAPI}/admin/analytics/${eventName}/aggregated`,
  getEventsProps: (eventName: string) =>
    `${api.withAPI}/admin/analytics/${eventName}/props`,
}
